import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import CONFIG from '../config';

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: true,
  pauseOnHover: true,
};

function PromotionSlider() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${CONFIG.API_BASE_URL}/promotion/banners/`)
      .then(res => res.json())
      .then(data => {
         console.log("Raw banners:", data.content) 
        setBanners(
          (data.content || [])
            .filter(b => b.is_active)
            .sort((a, b) => a.order - b.order)
        );
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{height: 314}}>Loading...</div>;
  if (!banners.length) return <div style={{height: 314}}>No banners</div>;

  return (
    <div style={{ width: '100%', maxWidth: 1200, margin: '0 auto', borderRadius: 16, overflow: 'hidden' }}>
      <Slider {...settings}>
        {banners.map((banner) => (
          <div key={banner.id}>
            <a href={banner.external_url} target="_blank" rel="noopener noreferrer">
              <img
                src={banner.image_url}
                alt={`promotion-${banner.id}`}
                style={{ 
                  width: '100%', 
                  height: 'auto',
                  aspectRatio: '1200/628',
                  objectFit: 'cover', 
                  borderRadius: 16, 
                  background: '#f2f2f2', 
                  display: 'block', 
                  margin: '0 auto' 
                }}
              />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default PromotionSlider;
